import Picture1 from '../../assets/picture1.png';
import Picture10 from '../../assets/picture10.png';
import Picture11 from '../../assets/picture11.png';
import Picture12 from '../../assets/picture12.png';
import Picture13 from '../../assets/picture13.png';
import Picture14 from '../../assets/picture14.png';
import Picture15 from '../../assets/picture15.png';
import Picture2 from '../../assets/picture2.png';
import Picture3 from '../../assets/picture3.png';
import Picture4 from '../../assets/picture4.png';
import Picture5 from '../../assets/picture5.png';
import Picture6 from '../../assets/picture6.png';
import Picture7 from '../../assets/picture7.png';
import Picture8 from '../../assets/picture8.png';
import Picture9 from '../../assets/picture9.png';

import PictureLarge1 from '../../assets/picture_large1.png';
import PictureLarge10 from '../../assets/picture_large10.png';
import PictureLarge11 from '../../assets/picture_large11.png';
import PictureLarge12 from '../../assets/picture_large12.png';
import PictureLarge13 from '../../assets/picture_large13.png';
import PictureLarge14 from '../../assets/picture_large14.png';
import PictureLarge15 from '../../assets/picture_large15.png';
import PictureLarge2 from '../../assets/picture_large2.png';
import PictureLarge3 from '../../assets/picture_large3.png';
import PictureLarge4 from '../../assets/picture_large4.png';
import PictureLarge5 from '../../assets/picture_large5.png';
import PictureLarge6 from '../../assets/picture_large6.png';
import PictureLarge7 from '../../assets/picture_large7.png';
import PictureLarge8 from '../../assets/picture_large8.png';
import PictureLarge9 from '../../assets/picture_large9.png';

const imageList = [
  Picture1, Picture2, Picture3, Picture4, Picture5,
  Picture6, Picture7, Picture8, Picture9, Picture10,
  Picture11, Picture12, Picture13, Picture14, Picture15,
];

const imageLargeList = [
  PictureLarge1, PictureLarge2, PictureLarge3, PictureLarge4, PictureLarge5,
  PictureLarge6, PictureLarge7, PictureLarge8, PictureLarge9, PictureLarge10,
  PictureLarge11, PictureLarge12, PictureLarge13, PictureLarge14, PictureLarge15,
];


export const detailText1 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
  <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
    <tbody>
      <tr>
        <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
        <td>공사, 품질, 안전, 보건, 공무, 정산 등 전반적인 배관 공정 관리 및 현장 유지</td>
      </tr>
      <tr>
        <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
        <td>인원 및 공정 관리, 단계별 품질 확보, 법적 기준의 무재해 안전관리, 일정 실행력</td>
      </tr>
      <tr>
        <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
        <td>끊임없이 개선을 추구하며 배려와 도덕성을 바탕으로 소통하는 협업 중심 현장</td>
      </tr>
      <tr>
        <td style="font-weight: bold; vertical-align: top;">팀 강점</td>
        <td>차별화된 기술력과 관리력을 통해 경쟁력을 확보한 전문조직</td>
      </tr>
      <tr>
        <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
        <td>“배관 공정의 완성도는 관리자의 품질, 안전, 일정에 대한 책임감에서 시작됩니다.”</td>
      </tr>
    </tbody>
  </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크는 고객사의 지속적인 투자에 걸맞게, 시공 품질은 물론 안전관리, 기술력, 인력 운영 능력까지 업계 최고 수준으로 끌어올리고 있습니다.
    같은 프로젝트라도 비비테크가 하면 다르다는 평가를 받을 수 있도록, 타사와는 차별화된 경쟁력을 만들어가고 있어요.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    비비테크는 공사, 품질, 안전, 보건, 공무, 정산관리 등, 현장 운영 전반을 체계적으로 관리하고 개선하는 역할을 맡고 있습니다.
    환경 개선부터 현장 유지관리까지, 안정적이고 효율적인 현장 운영을 위한 핵심 업무를 수행하게 됩니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    <strong>• 공사 관리</strong><br/>
    공사 관리 직무는 말 그대로 공사가 시작되기 전부터 끝날 때까지 전 과정을 책임지는 역할이에요.
    공사 일정과 업무 내용을 꼼꼼히 분석해서, 필요한 설비와 인력을 언제 어디에 투입할지 계획하고,
    착공 전 사전 작업과 현장 정리를 통해 현장의 문제없이 돌아갈 수 있도록 준비하는 일을 맡습니다.<br/><br/>

    <strong>• 품질 관리</strong><br/>
    품질 관리 직무는 시공 중 발생할 수 있는 문제를 미리 점검하고, 완성도를 높이는 일을 합니다.
    체계적인 품질관리 계획을 세우고, 공정마다 점검과 검사를 통해 불량이나 오류가 없도록 관리하죠.
    기록도 중요해서, 관련 자료 정리와 품질 개선 활동도 함께 맡게 됩니다.<br/><br/>

    <strong>• 안전 관리</strong><br/>
    안전 관리 직무는 모든 현장의 기본이 되는 안전을 책임지는 역할이에요.
    사고를 예방하기 위한 계획을 세우고, 전 직원의 안전의식을 높이는 교육과 시스템을 운영합니다.
    보건관리와도 함께 움직이며 근로자의 건강과 작업장의 안전을 동시에 챙깁니다.<br/><br/>

    <strong>• 공무 관리</strong><br/>
    공무 관리 직무는 현장을 뒷받침하는 실무 전반을 담당합니다.
    작업일보, 허가서, 문서 검토 같은 행정업무부터, 인허가 절차나 자재 신청 등 실질적인 업무 처리까지 맡고 있어요.
    현장이 매끄럽게 운영될 수 있도록 조율하고 지원하는 역할입니다.<br/><br/>

    <strong>• 정보 관리</strong><br/>
    정보 관리 직무는 설계 도면, 보고서, 각종 자료들을 정확하고 체계적으로 정리하는 일을 합니다.
    CAD 작업이나 전산 정리를 통해 업무 데이터를 누락 없이 기록하고,
    하드웨어나 소프트웨어도 잘 작동하도록 관리해 업무 효율을 높이는 지원자 역할도 함께 수행해요.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크의 현장은 끊임없이 발전을 위해 노력하고, 서로를 배려하며 소통하는 건강한 팀워크를 바탕으로 움직입니다.
    기술뿐 아니라 도덕성과 책임감도 함께 갖춘 현장을 지향하고 있어요.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    배관과 공정의 흐름 속에서, 기술과 사람의 가치를 함께 고민하고 성장할 여러분을 환영합니다.
  </p>
</div>
`;

export const detailText2 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>삼성전자 PJT 및 2차 배관 유지보수공사 수행, 전반적인 현장 운영과 고객사 관리</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>주인의식과 책임감, 전체 흐름을 보는 판단력, 대내외 신뢰를 주는 행동력</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>자율적이고 체계적인 업무 진행, 상호 협업과 토론 중심의 문제 해결 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀 강점</td>
          <td>공과사를 명확히 구분하는 존중 문화, 강제 없는 회식 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“배관은 반도체 공정의 혈관입니다. 그 중심에서 기술력과 자부심을 키우길 바랍니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    삼성전자 2차 배관 유지보수 공사는 기존 설비의 안정적 운영을 위해 정기적으로 점검하고 보수하는 작업을 수행합니다.
    삼성전자 PJT 공사는 신규 또는 증설 프로젝트에 참여하여 배관 시공, 설비 설치 등 주요 공정을 책임지고 진행합니다.
    고객사 관리는 공사 진행 전반에 걸쳐 고객과의 소통을 통해 요구사항을 반영하고, 품질과 일정, 안전 측면에서 신뢰를 구축하는 역할을 합니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요.</h3>
  <ul>
    <li>현장소장은 전체 공정을 총괄하며 현장의 흐름을 조율하는 핵심 역할을 맡습니다.</li>
    <li>사업장 내 계약된 SITE 직원들의 근무 상황과 인력 운영을 관리하고, 관련 금전 흐름도 체계적으로 운영합니다.</li>
    <li>시공, 품질, 안전, 공무 등 다양한 부서를 조율하며 현장의 컨트롤타워 역할을 수행합니다.</li>
    <li>발주처와의 커뮤니케이션을 주도하며 요구사항을 반영하고, 대응과 협의를 통해 신뢰 관계를 유지합니다.</li>
  </ul>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    강한 책임감과 주인의식을 가지고, 맡은 현장을 내 일처럼 생각하는 태도가 필요합니다.
    모든 상황에 즉각 반응하기보다, 한 걸음 물러나 전체를 파악한 뒤 신중하게 판단할 수 있는 균형감 있는 결단력이 중요합니다.<br/><br/>
    현장에서는 고객사와 직원 모두에게 신뢰를 줄 수 있는 태도와 일관된 행동이 필수입니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    직원들 간에는 항상 서로 토론하고 협업하면서 문제를 함께 해결해 나가는 분위기입니다.
    모든 업무는 명확한 프로세스를 먼저 정립하고, 체계적으로 진행하는 걸 원칙으로 합니다.<br/><br/>
    공과 사를 확실히 구분하기 때문에, 개인의 생활이나 활동도 존중받을 수 있는 환경이에요.
    회식처럼 개인 일정이 걸린 부분은 반드시 사전에 의사를 묻고, 강제 없이 자율적으로 참여하도록 하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    동종 업계와 비교해도, 우리 사업부의 분위기는 최고라고 자부할 수 있습니다.
    업무 특성상 조직적인 흐름은 있지만, 각자의 성향과 상황을 충분히 배려하며 협업하는 분위기를 지향합니다.<br/><br/>
    반도체 산업은 아직도 무한한 발전 가능성을 가진 분야입니다.
    양산까지 수많은 공정이 존재하지만, 배관공사는 그 모든 공정을 연결하는 ‘혈관’ 같은 핵심 역할을 한다고 생각합니다.
    그만큼 중요한 일을 하고 있다는 자부심을 가질 수 있고, 기술력을 키워갈수록 더욱 큰 자신감과 의미를 느낄 수 있는 분야입니다.
  </p>
</div>
`;

export const detailText3 = `
<div style="line-height: 1.6; font-size: 1.6rem; color: #333;">
  <!-- 요약 테이블 -->
  <div style="font-size: 1.4rem; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>반도체 배관 시공 및 설치 총괄, 자재·공정·인력 등 현장 운영 전반을 통합 관리</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>시공 및 공정 리딩, 협력사 및 내부팀과의 유기적 소통, 설계 도면 해석 능력, 장비·배관 기술 이해도</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>정확성과 속도를 중시하는 분위기, 팀워크와 현장 책임감 강조</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀 강점</td>
          <td>다수의 현장 경험으로 쌓인 문제 해결력과 실행력, 다양한 조건에도 유연한 프로젝트 대응</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“작은 일 하나도 함께 고민하고 책임지는 자세, 그런 분이 우리 팀의 또 다른 리더가 될 수 있습니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 부서는 반도체 제조설비에 필요한 배관 시공과 설치를 종합적으로 담당하고 있습니다. 공정별 일정과 자원 투입 계획을 체계적으로 수립하며, 현장에서의 시공과 공정을 안정적으로 관리하는 역할을 수행합니다.<br /><br />
    동시에 품질 관리와 안전 관리를 철저히 이행하고, 설계 도면 검토와 기술적 문제 해결을 통해 현장의 완성도를 높이고 있습니다. 또한 고객사와 협력사와의 긴밀한 협업을 통해 공정이 원활히 진행될 수 있도록 조율하는 것도 중요한 책무입니다.<br /><br />
    특히, 설비의 배관은 인체의 혈관에 비유할 수 있을 만큼 핵심적인 요소로, 반도체 설비가 정상적으로 기능하기 위해 반드시 갖추어야 할 기반을 담당하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    저는 소장으로써 반도체 제조공정 설비에 필요한 배관 공사의 현장 관리 및 시공을 총괄합니다.
  </p>
  <ul>
    <li>현장 공정 관리 : 배관 공사 일정 수립과 진행 상황 점검, 단계별 품질 확인을 수행합니다.</li>
    <li>안전 관리 : 산업안전보건법 및 고객사 기준에 따른 현장 안전 수칙을 철저히 준수하고 지도합니다.</li>
    <li>자재 및 인력 관리 : 공사에 필요한 자재 수급을 관리하고 작업자 배치 계획을 수립합니다.</li>
    <li>도면 및 시공 검토 : 설계 도면을 검토하여 시공 가능 여부를 확인하고, 기술적 이슈 발생 시 적절히 대응합니다.</li>
    <li>협력업체 및 발주처 소통 : 고객사 및 2차 협력업체와의 일정 조율과 원활한 커뮤니케이션을 담당합니다.</li>
    <li>공정 품질 관리 : 시공 후 품질 검사, 가압 및 기밀 테스트 등 주요 검사 항목을 수행하고 결과를 보고합니다.</li>
    <li>현장 문서 작성 및 보고 : 공사 일지, 작업 허가서, 안전 교육 자료 등 각종 현장 문서를 작성하고 보고합니다.</li>
    <li>완료 후 정산 : 시공 완료 후 최종 물량을 시스템에 기입하여 정산 금액을 산출합니다.</li>
  </ul>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양은 무엇이 있을까요?</h3>
  <ul>
    <li><strong>공정과 시공을 효율적으로 관리할 수 있는 분</strong><br/>반도체 현장은 여러 작업이 동시에 진행되기 때문에, 배관 공사의 일정과 품질을 놓치지 않고 조율할 수 있는 감각과 경험이 중요해요. 시공 계획을 짜고, 자원을 적절히 배분하며 현장을 운영해본 경험이 있다면 더 좋습니다.</li><br />
    
    <li><strong>현장에서 문제를 빠르게 해결할 수 있는 분</strong><br/>자재 지연, 설비 간섭, 설계 오류처럼 예상치 못한 상황도 자주 발생하죠. 그럴 때 빠르게 판단하고 이해관계자들과 협의해 최선의 방법을 찾아낼 수 있는 능력이 필요해요.</li><br />
    
    <li><strong>안전을 최우선으로 생각하는 책임감 있는 분</strong><br/>고위험 작업이 많은 현장이다 보니, 작업자들의 안전을 위한 사전 점검과 교육은 필수입니다. 관련 법규나 안전 기준에 대한 이해도 함께 필요해요.</li><br />
    
    <li><strong>말이 잘 통하고 협업에 강한 분</strong><br/>고객사, 협력사, 내부 팀과의 소통이 원활해야 공정이 매끄럽게 돌아갑니다. 각기 다른 작업이 동시에 진행되는 반도체 현장에서 유기적인 협업이 가능한 분을 기다립니다.</li><br />
    
    <li><strong>도면과 기술에 대한 이해도가 높은 분</strong><br/>2D/5D 배관 도면을 정확히 해석하고, 고순도 가스나 케미컬 배관처럼 특수 설비에 대한 기술적 이해가 있는 분이면 금상첨화예요.</li><br />
    
    <li><strong>현장을 이끄는 리더십이 있는 분</strong><br/>배관 작업은 다양한 인력과 함께하는 일이라 사람을 잘 보고, 현장을 이끌고, 좋은 분위기를 만드는 능력도 중요합니다. 작업자 각각의 성향과 역량을 고려한 배치와 동기 부여도 필요하죠.</li><br />
    
    <li><strong>책임감 있게 끝까지 해내는 분</strong><br/>공정, 품질, 안전을 동시에 챙기는 역할인 만큼 묵묵하게 책임지고, 꾸준하게 믿음을 줄 수 있는 분이라면 비비테크와 정말 잘 맞을 거예요.</li>
  </ul>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <ul>
    <li><strong>정확하면서도 빠르게 움직이는 실무 중심 조직</strong><br />
      반도체 산업은 정밀함과 납기 준수가 생명이기 때문에, 업무는 늘 체계적이고 빠르게, 실수 없이 처리하는 문화를 갖고 있어요. 보고나 의사결정도 복잡하게 돌리지 않고 신속하게 이루어지고, 문제가 생기면 바로 해결부터 하는 게 원칙입니다.
    </li><br />

    <li><strong>수직적인 구조지만, 실용적인 소통이 살아있는 현장</strong><br />
      역할과 책임은 명확하게 나뉘어 있어요. 공사·안전·품질·공무 등 각 분야 전문가들이 자기 역할을 분명히 수행하면서도, 현장에서는 실적과 문제 해결 능력 중심의 실용적인 소통이 활발해요.<br />즉, 직급보다 실력이 중요한 문화죠.
    </li><br />

    <li><strong>협업 없이는 돌아가지 않는 현장</strong><br />
      구매팀, 환경안전팀, FQM팀, 스마트팩토리팀 등 타 부서 및 협력사와의 긴밀한 협업이 핵심이에요. 여러 공정이 동시에 돌아가기 때문에, 일정 충돌을 막고 시너지를 만드는 유기적 조율력이 정말 중요하죠.
    </li><br />

    <li><strong>강도 높은 실무 속에서도 살아있는 팀워크</strong><br />
      현장은 늘 바쁘고 일정은 촉박합니다. 업무 강도는 높은 편이지만, “그래도 팀워크는 최고”라고 자부할 수 있는 분위기입니다. 힘든 와중에도 서로를 챙기고 함께 나아가는 힘이 있어요.
    </li><br />

    <li><strong>경험과 실전 노하우가 진짜 자산</strong><br />
      이 분야는 경험이 실력입니다. 경력자의 말에 귀 기울이고, 실전에서 우러난 노하우를 존중하는 문화가 자리잡고 있어요. 자연스럽게 배우고 나누는 분위기가 형성되어 있답니다.
    </li><br />

    <li><strong>문제 발생 시엔 원인보다 ‘해결’이 먼저</strong><br />
      현장에서는 문제를 따지는 시간보다 “먼저 해결하고, 나중에 리뷰”하는 게 더 중요해요. 일이 잘 마무리되면, 누가 했느냐보단 팀 전체의 성과로 인정받는 문화입니다. 책임을 미루기보단 함께 해결하려는 태도가 기본이에요.
    </li>
  </ul>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    우리 부서는 반도체 산업의 최전선에서 실제 설비가 구축되는 핵심 현장을 책임지고 있습니다. 업무 강도가 높고 예측하기 어려운 상황도 많지만, 그만큼 성취감도 크고 빠르게 성장할 수 있는 환경입니다.<br/><br/>
    우리는 서로를 ‘가족’이라 부르며, 혼자 잘하는 사람보다 함께 문제를 해결할 수 있는 사람을 더 중요하게 생각합니다. 현장에서는 꼼꼼함, 책임감, 그리고 긍정적인 자세가 무엇보다 큰 힘이 됩니다.<br/><br/>
    배우려는 자세와 함께 현장을 즐길 수 있는 분이라면, 저희와 함께 좋은 경험을 만들어갈 수 있을 것입니다. 반도체 산업의 정밀함과 현장의 생동감을 모두 느껴보고 싶다면, 꼭 지원해 주세요.
  </p>

</div>
`;

export const detailText4 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>배관 자동화 설비 개발과 운영을 통해 제조 공정의 효율성과 정밀도 극대화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">중요 업무</td>
          <td>오토벤딩, 컬링머신, 스파이럴 덕트 자동화 및 스마트팩토리 시스템 운영 전반을 담당</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>기계 시스템 이해는 기본, 협업을 이끄는 커뮤니케이션 역량 중시</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>수평적 의사소통, 빠른 실행력, 강한 팀워크</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀의 강점</td>
          <td>설계부터 시공까지 전 공정을 자동화하는, 반도체 제조 자동화의 중심 부서</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“지금 도전하세요. 당신의 기술과 성장이 함께 만들어질 곳입니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    스마트팩토리사업부는 설계부터 시공까지, 전 공정을 자동화하는 비비테크의 핵심 부서입니다.<br />
    우리는 단순히 효율을 높이는 걸 넘어, 반도체 제조 현장의 미래를 바꾸는 자동화 기술을 개발하고 적용하고 있어요.
    설비 효율성과 생산 정밀도를 극대화하는 게 목표이며, 자동화된 시스템을 통해 더 빠르고, 더 정확하고, 더 안전한 현장을 만들어 갑니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <ol>
    <li>스마트팩토리사업부는 삼성전자 S5D 및 디노(DINO) 도면을 자체 개발한 Auto Bending Compiler로 변환하고 최적화하는 자동화 설계를 수행합니다.</li><br />
    <li>오토벤딩 운영은 튜브 커팅 및 벤딩 장비를 운용하고, 레이저 마킹과 이력 관리를 통해 Spool 가공 후 조립 품질을 점검합니다.</li><br />
    <li>컬링머신 자동화는 1500/1000/700/500mm의 표준 사이즈 배관을 Auto Curling Machine, 면취기, 포밍기로 생산하며, 표준화율을 높이고 자재 손실을 최소화합니다.</li><br />
    <li>스파이럴 덕트 자동화는 BOM 기반 자재 분출 자동화 및 개별 길이 커팅을 통해 협력사 맞춤 생산에 대응하고 품질을 안정화합니다.</li><br />
    <li>스마트팩토리 시스템 운영은 BOM 데이터 검증, 자재 Loss율 분석, 생산 실적 관리 및 ERP 시스템 연동까지 자동화 생산의 전 과정을 통합 관리합니다.</li>
  </ol>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양은 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    기계와 시스템에 대한 이해는 기본입니다. 하지만 그보다 중요한 건 사람과의 협업을 이끄는 커뮤니케이션 역량입니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    소통이 빠르고, 문제는 함께 해결합니다. 수평적인 의사소통, 자유로운 제안, 그리고 빠른 실행력이 우리 팀의 가장 큰 강점입니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    스마트팩토리사업부는 반도체 및 제조 자동화의 미래를 이끌어갈 중심 부서입니다.
    탄탄한 교육과 실무 중심의 프로젝트, 그리고 빠르게 성장할 수 있는 기회가 당신을 기다리고 있습니다.<br/>
    지금, 도전하세요. 함께 만들어 갑시다.
  </p>
</div>
`;

export const detailText5 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">담당 업무</td>
          <td>반도체 배관 도면을 자동화 프로그램에 맞춰 설계하고 ABM 설비를 활용한 제작 연계</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>배관 형상에 대한 이해, 3D 설계 도구 활용 능력, 휴먼에러를 줄이는 꼼꼼함</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원 동기</td>
          <td>그동안 쌓은 기술과 경험을 가장 잘 활용할 수 있는 부서라고 판단하여 지원</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>구성원 간 배려와 소통이 자연스럽고 협업 시 빠른 피드백과 지원이 이루어짐</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">입사 후 바람</td>
          <td>회사가 성장해 비비테크라는 이름만으로도 외부의 신뢰와 부러움을 받길 희망</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">인상 깊은 순간</td>
          <td>퇴근 시간이 되면 전원이 자연스럽게 정시 퇴근하는 모습이 인상적이었음</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">입사자 조언</td>
          <td>비비테크는 계속 성장 중인 회사니 포기하지 말고 끝까지 도전하길 바랍니다</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    저는 스마트팩토리 사업부에서 오토밴딩 관련 설계 업무를 하고 있습니다.<br/>
    반도체 현장의 설계 도면을 바탕으로 저희 자동화 프로그램에 맞추어 설계하고, ABM 설비를 활용해 제작하는 업무를 하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 해당 업무에서 가장 중요한 역량 및 소양은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    가장 중요한 역량은 배관 형상에 대한 이해도와 휴먼에러를 최소화하는 꼼꼼함입니다.<br/>
    그리고 반도체 현장에 대한 감각과 3D프로그램의 숙련도도 필요한 부분입니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 우리 회사의 해당 부서에 지원한 이유는 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    제가 지금까지 갖추었던 능력들을 모두 활용할 수 있는 부서라고 생각하여 지원하게 되었습니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 부서의 조직원들은 서로를 배려하고 궁금한 것이 있으면 언제든지 친절하게 알려주는 화목한 분위기 입니다.
    협업을 할 때도 마찬가지이며 작업에 불편한 점은 없는지 서로의 니즈를 알아주려하고 빠르게 해결해주려는 문화를 가지고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 회사는 계속 커지고 있기 때문에 포기하지말고 계속 도전하셨으면 좋겠습니다.
  </p>

  <h3 style="font-size: 2rem;">Q6. 입사 후 가장 인상 깊었던 순간은?</h3>
  <p style="font-size: 1.4rem;">
    퇴근 시간이 되면 저희 사무실에 있는 직원들이 누구 한명 남지 않고 정시 퇴근하는 모습이 가장 인상 깊었습니다.
  </p>
</div>
`;

export const detailText6 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>비비테크의 신규 사업을 발굴하고 창출하는 개척형 부서</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">중요 업무</td>
          <td>신규 아이템 기획, 기술영업, 프로젝트 운영 전반</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>창의성, 주도성, 살아있는 사고력, 기초적인 기획 및 문서화 역량</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>권위보다 집단 지성을 중시하는 자율적 협업 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“능력보다 중요한 건 자율성과 적극성입니다. 스스로 하고자 하는 사람을 기다립니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크는 기존의 기술력에 머무르지 않고, 새로운 사업 기회를 끊임없이 발굴하고 확장해 나가고 있어요.<br />
    저희 부서는 변화하는 산업 흐름에 맞춰, 기존 영역을 넘는 신규 사업 분야를 창출하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    새로운 사업 기회를 발굴하고, 기술 기반의 제안 영업과 프로젝트 실행까지 전 과정을 주도적으로 운영하고 있어요. 단순히 주어진 일만 하는 게 아니라, 아이템을 직접 기획하고, 시장과 기술을 연결해 성과로 만들어가는 역동적인 역할입니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양은 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    정해진 일만 반복하기보다는, 새로운 시각으로 문제를 해결하고 제안하는 태도를 중요하게 생각해요. 그래서 창의적인 사고와 적극적인 실행력, 그리고 현장을 읽는 ‘살아있는 감각’이 꼭 필요합니다.<br />
    물론, 기본적인 문서 정리나 보고 등 Paper work 능력도 함께 갖춘 분이라면 더할 나위 없죠.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    권위나 카리스마에 의존하는 조직문화를 지양합니다.<br />
    대신, 서로의 의견을 존중하고 자율성을 바탕으로 문제를 함께 풀어가는 문화를 만들어가고 있어요.<br />
    혼자 끌고 가는 리더보다, 모두가 참여해 해결책을 찾는 집단 지성의 힘을 더 믿습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    학벌이나 스펙보다는 ‘어떻게 일하느냐’를 더 중요하게 생각합니다.<br />
    누가 시켜서 움직이기보다, 스스로 문제를 발견하고 해결하려는 태도, 바로 그 주도성과 적극성이 비비테크가 원하는 핵심 역량이에요.
  </p>
</div>
`;

export const detailText7 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>NCK 내 유틸리티 설비 운영 및 특수가스 공급장치 유지보수 담당</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">중요 업무</td>
          <td>고압가스, 유해화학물질, 공조설비, CDA·LN2·소방 등 Demo FAB 기반 설비 운용</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>고압가스 관련 자격과 직무 경험, 사고 예방을 위한 꼼꼼함과 책임감</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>수평적이고 친근한 분위기 속에서 자유롭게 소통하며 문제 해결 중심의 협업</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“산업의 기반이 되는 유틸리티를 안정적으로 운영하며, 개인의 커리어와 사회적 책임을 함께 실현해가는 일에 도전해보세요”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크는 히타치 Demo FAB의 안정적인 운영을 위해 NCK 유틸리티 설비와 건물 위탁 관리 업무를 수행하고 있어요. 고압가스와 유해화학물질 공급장치, FAB 공조설비, PCW, CDA, 액체질소(LN2), 소방 시스템 등 다양한 핵심 설비의 안정성과 효율을 책임지고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    담당업무는 NCK 내 유틸리티 설비 유지보수 및 관리이며 주요 직무 내용으로는 NCK 특수가스의 안정공급 및 공급장치 유지보수를 담당하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    제가 담당하고 있는 특수가스의 안정공급 및 공급장치 유지보수의 업무에서는 가장 먼저 고압가스에 관한 기본적인 지식이 중요하다고 생각합니다.
    이를 위해서는 관련 자격증의 공부와 취득이 도움이 된다고 생각합니다.<br />
    저 역시도 가스관련 자격증 취득과 유사한 직무경험을 통해서 새로운 환경에 적응하는데 도움이 되는 것 같습니다.<br /><br />

    또한 고압가스 및 독성 및 가연성 가스 등의 취급에 따른 위험성이 존재하고 가스 사고의 경우 막대한 피해와 손실이 일어날 수 있기 때문에 
    사고를 예방하고 손실(Loss)을 최소화 하기 위해 가스안전관리자로서의 책임감과 자부심을 가지고 
    평소 일상점검 시 꼼꼼하게 확인하는 태도가 중요하다고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    먼저 부서장님을 비롯하여 부서원들과 편안하고 친근한(수평적) 분위기에서 업무를 담당하고 있습니다.<br />
    공통의 업무나 과제 수행 시에는 다같이 협업하여 빠르게 문제를 해결하고 정기적인 회의를 통해 업무 내용을 공유하고 
    각 담당자들의 의견 제시 및 수렴을 통하여 더 나은 방안을 모색하고자 노력하고 있습니다.<br />
    또 업무나 회의 진행 시 간단한 음료와 다과를 먹으며 편안하고 자유로운 분위기 조성하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크는 고객사인 삼성전자에 HOOK-UP 기술과 노하우를 인정받고 있는 회사입니다.<br />
    제가 몸담고 있는 SE사업부는 히타치하이테크코리아와 협약을 맺어 NCK(Nanotechnology Innovation Center Korea)를 개소하여 웨이퍼 식각설비인 Etcher 설비를 운영하고 있습니다.<br /><br />

    히타치와의 협업을 통해 Utility 운영 및 Demo Fab 운영기술등 지속적인 성장을 이루고 기업의 사회적 책임을 다하며 함께 어우러지는 세상을 만들기 위해 노력하고 있습니다.<br /><br />
    이를 통해 개인의 커리어 향상과 함께 인근 지역과 사회와 동반성장 할 수 있는 좋은 계기가 될 수 있을 것이라고 생각합니다.
  </p>
</div>
`;

export const detailText8 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>안전, 시설, 소방, 차량, 전기, 품질, 환경 등 공장 운영의 기반 전반을 총괄</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>안전·환경·품질·보건 등 공장 유지관리에 필요한 모든 기술적 이해와 종합적 운영 능력</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 분위기</td>
          <td>각 파트를 연결하고 이끄는 ‘주장’ 같은 리더십, 협업 중심의 실무 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀의 강점</td>
          <td>공장 전체를 최적 상태로 유지하며, 다양한 변수에 유연하게 대응하는 통합 관리</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“비비테크에서 여러분의 역량과 꿈을 펼칠 기회를 잡으세요!”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    ST사업부는 화성 전공해양일반산업단지내에 위치하고 있으며 반도체 설비에 필요한 훅업, 진공 파이프, 덕트, CPI 등에 필요한 테프론 코팅 업무를 수행하고 있으며 부서는 코팅 작업에 전념하는 생산부와 품질관리, 설비 유지 및 안전관리 등의 업무를 수행하는 관리부로 구성되어 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    시설물 및 설비 유지 보수, 안전보건, 환경 및 소방안전관리 등 화성공장이 무재해 사업장으로서 생산성이 향상되도록 안전관리직무를 수행하고 있으며 많은 경험을 토대로 필요시, 검수업무를 통한 품질관리, 제품 출하업무도 병행하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양은 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    안전, 보건, 소방, 환경, 품질, 시설물 관리, 고충 처리 등 모든 업무가 중요하며 따라서, 각 분야별 관련된 법령과 규정을 이해하고 현장에 맞게 적용하며 안전문화를 주도하면서 피드백을 통하여 불합리 사항을 조치 개선하는 실행능력이 요구됩니다. 
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    각 파트별 전문성을 갖추고 있으며 모두들 공정별 서로의 역할을 존중하고 혼연일체하여 생산목표를 달성하고 있으며 밝고 건강한 분위기로 근무하고 있습니다
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크에 입사하여 꿈을 펼칠 기회를 잡으세요 ^^
  </p>
</div>
`;

export const detailText9 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>설계, 자재·장비 조달, 시공 등 1차 플랜트 프로젝트 전반의 실적 및 공무 업무 담당</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">주요 업무</td>
          <td>공사 내역서 검토, 물량산출, 증빙자료 작성, 노무비 및 외주 기성 정리 등</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>수치 기반 업무에 필요한 정밀함, 변화 사항에 대한 빠른 반영, 유관 부서 및 협력사와의 소통력</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>철저한 역할 분담과 팀워크 중심의 협업 체계</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“작은 수치 하나도 공사의 흐름을 바꿉니다. 꼼꼼함과 책임감 있는 분이라면 충분히 성장할 수 있습니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    EPC사업부는 설계, 자재 및 장비 조달, 시공 등 1차 플랜트 프로젝트 관리를 수행하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    공사 내역서 검토 및 물량산출, 증빙자료 작성 / 월별 투입비 정리 등 실적 관리 / 노무비 및 외주 기성 정리를 하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    문서상의 수치, 단가, 수량, 금액 계산 등 업무가 정산 및 지급과 직결되는 만큼 정확한 판단과 업무 수행이 필요하며 공사 진행에 따른 변경 사항을 정확히 반영하며 관리해야 하고 협력사, 내부 부서와의 소통 역량이 중요하다고 생각합니다. 
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    부서 내에서는 팀워크가 매우 중요하며, 각자의 역할에 맞춰 철저히 협력해야 하는 만큼 각 팀과 원활한 커뮤니케이션과 조율이 이루어져야 효율적인 업무 진행이 가능합니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    작은 실수도 큰 영향으로 이어질 수 있기 때문에 정확한 보고와 책임감이 가장 중요합니다. 팀워크를 중시하고 섬세한 업무 스타일을 가진 분이라면 공사의 전반적인 부분을 이해하면서 충분히 역량을 발휘하며 성장할 수 있을 거라 생각합니다.
  </p>
</div>
`;

export const detailText10 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>자재 입고부터 시공 완료까지의 품질 전반을 관리하며, 고객 요구사항과 규정 준수를 기준으로 품질 체계 수립</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">중요 업무</td>
          <td>현장 제작품의 적합 여부 판정, 부적합 데이터 기록 및 개선 시스템 운영</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>정확한 판별력, 문제 원인 분석 능력, 재발 방지를 위한 시스템적 사고</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>문제 발생 시 열린 논의와 피드백 중심, 개선을 위한 자유로운 협업 분위기</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“꼼꼼함과 책임감이 핵심입니다. 함께 신뢰받는 품질을 만들어갈 분을 기다립니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    반도체 배관의 자재 입고부터 시공완료까지 품질을 관리하며 , 고객의 요구사항과 규정 준수를 반영한  품질 기준을 수립하고 체계적으로 관리하는 것이 주요 역할입니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    현장에서 요청한 제작품이 기준에 맞게 제작 되었는지 적부 판정하여 문제없이 입고될 수 있도록 하며 부적합 제품에 대한 데이터 기록관리를 하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    품질 관련하여 요구되는 사항은 제품에 적부 판정을 정확하게 판별하기 위한 정확성과 발생 원인이 무엇인지 파악하고 재발방지 및 시스템 구축을 위한 업무에 관련한 지식입니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    문제가 발생하였을 때에 함께 논의하고 재발을 방지하며 개선하기위한 소통이 중심이 되기에 상호 피드백을 자주 주고받으며 자유로운 분위기 입니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    반도체 품질 업무는 작은 오류도 큰 영향을 줄 수 있어 꼼꼼함과 책임감이 중요합니다. 함께 신뢰받는 품질을 만들고, 다양한 개선을 주도해 나아갈 인재를 기다립니다.
  </p>
</div>
`;

export const detailText11 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>비비테크 내 모든 구성원이 안전하고 건강한 작업환경에서 일할 수 있도록 예방 중심의 안전·보건 관리를 수행</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>책임감, 소통 능력, 문제 해결력을 바탕으로 위험 요소를 선제적으로 발견하고, 실질적 개선</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 분위기</td>
          <td>현장 중심의 유연한 대응과 팀원 간 신뢰를 기반으로 열린 소통과 협력이 자연스럽게 이뤄지는 부서</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀의 강점</td>
          <td>법적 기준 이상의 안전관리와 고객 대응 역량을 갖춘, 전사 안전문화의 중심 부서</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“작은 위험도 크게 보는 시선으로, 누군가의 하루를 더 안전하게 만드는 일에 함께 해주세요.”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    비비테크 內 근로자의 안전한 환경에서 작업할 수 있도록 지원하는 부서로, 현장 내 위험요소를 사전에 점검하고 개선하며, 법적 기준과 고객사의 요구사항을 충족하는 안전관리 체계를 운영합니다. 사고 예방과 안전문화 정착을 위해 다양한 부서와 협업하며 실질적인 안전,보건관리를 수행하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    보건관리자는 산업안전보건법 및 중대재해처벌법에 따른 법적 의무를 이행하며, 현장 점검을 통해 위험 요소를 사전에 파악하고 제거합니다. 신규자·정기·특별 안전보건 교육과 훈련을 실시하고, 고객사의 업무 요청에도 신속하게 대응합니다.<br /><br />
    ISO 45001 인증 연장 및 사후 심사를 준비하며, 하도급 업체 관리와 전사 안전문화 활동도 주도합니다. 근로자의 일반·특수건강검진을 체계적으로 관리하고, 유소견자 및 근골격계, 직무스트레스, 뇌심혈관 질환 등 주요 건강 리스크를 지속적으로 모니터링합니다.<br /><br />
    또한, 작업환경측정을 통해 작업장의 유해 요인을 관리하고 개선하는 역할을 수행합니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    책임감, 소통 능력, 문제 해결력, 안전업무는 단순히 규정을 지키는 것을 넘어, 현장의 위험요소를 발견하였을 때 실질적인 개선 방안을 찾아내고 해결하는 과정입니다.<br /><br />
    그만큼 맡은 일에 책임감을 가지고 끝까지 관리하는 태도, 여러사람들과의 원활히 소통하는 능력, 그리고 위험요소나 이슈 발생시 빠르게 파악하고 실질적인 대안을 제시하는 문제 해결력이 매우 중요합니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    서로의 의견을 존중하고 열린 소통을 지향하는 부서, 업무 특성상 현장 대응이 많고 다양한 상황을 마주하게 되지만, 그만큼 팀원 간 협력과 지원이 자연스럽게 이뤄지는 문화가 자리 잡혀 편안하지만 책임감 있는 분위기 속에서 모두가 함께 배우고 성장해 나가는 부서입니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    안전은 현장의 기본이자 모두의 권리입니다. 작은 위험을 크게보고, 저희와 함께 안전/보건관리를 진행하며 누군가의 하루를 더 안전하게 만들어 보아요.
  </p>
</div>
`;

export const detailText12 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">담당 업무</td>
          <td>4대 보험 자격관리, 건강검진 계획·사후관리, 법정 안전교육 운영, 직무 인증·안전용품 관리 등 근로자의 안전과 복지를 위한 전반적 행정·실무 지원</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>법적 기준에 따른 정확한 실행력, 일정과 데이터를 놓치지 않는 꼼꼼함, 그리고 외부 기관과의 협업을 위한 친절하고 명확한 소통 능력</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원 동기</td>
          <td>현장 경험을 통해 안전관리의 핵심성을 체감하였고, ‘안전이 최우선 경영’이라는 철학에 공감해 실질적 기여가 가능한 안전전문가로 성장하고자 지원</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>신뢰와 존중을 바탕으로 한 협력 중심의 팀워크, 어려운 상황에도 자발적으로 돕는 유연한 분위기, 따뜻하고 사람 중심의 조직</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">성장 방향</td>
          <td>현장과 행정 모두를 아우르는 실무형 안전관리자로 성장하고, 법규에 기반해 주도적으로 현장을 리드하는 역량을 갖추는 것이 목표</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원자에게 한마디</td>
          <td>어려움은 누구에게나 옵니다. 비비테크는 서로 기대고 함께 해결하는 문화가 살아있는 곳입니다. 혼자 감당하지 마세요.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 현재 맡고 있는 담당 업무와 직무 내용은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    현재 환경안전팀에서 근로자들의 안전과 복지 관리를 담당하고 있습니다.<br/>
    구체적으로는 반도체현장 내에서 근무하는 인력들의 4대보험 자격 취득 및 상실 신고에 필요한 서류를 관리하고 있으며, 산업안전보건법에 따른 건강검진을 계획하고, 시행 및 사후 결과 관리까지 맡고 있습니다.<br/><br/>
    또한 신규 입사자 교육, 정기/특별 안전교육 등 법정 안전교육을 일정에 맞춰 기획하고 운영하고 있고, 근무에 필요한 직무인증 취득 절차와 안전용품 관리 업무도 함께 수행하고 있습니다. 전반적으로 근로자가 법적 기준에 따라 안전하고 효율적으로 근무할 수 있도록 행정적, 실무적으로 지원하는 역할을 하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 해당 업무에서 가장 중요한 역량 및 소양은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    제 업무는 대부분 법적 기준에 따라 정확하게 이행되어야 하므로, 세세한 부분까지 꼼꼼히 확인하고 일정에 차질 없이 업무를 관리하는 책임감과 정확성이 가장 중요하다고 생각합니다.<br/><br/>
    또한 근로자뿐 아니라 병원, 교육기관 등 외부 기관과 협력할 일이 많기 때문에 정확하고 친절하게 소통할 수 있는 커뮤니케이션 능력도 중요한 역량이라고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 우리 회사의 해당 부서에 지원한 이유는 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    이전에 품질 및 공사관리 업무를 맡으며 현장에서 다양한 경험을 쌓았습니다. 그 과정에서 작업의 시작부터 문제 해결, 마무리까지 전반적인 상황을 신속하게 파악하고 대응한 부서가 바로 안전팀이었습니다. 이를 통해 ‘안전관리’는 단순한 규정 준수를 넘어, 근로자와 회사 모두의 자산을 보호하는 중요한 업무임을 깨닫게 되었습니다.<br/><br/>
    특히 비비테크의 ‘안전이 최우선 경영’이라는 슬로건을 보며 자연스럽게 안전관리 업무에 대한 관심을 가지게 되었습니다. 이러한 경험과 인식을 바탕으로, 좋은 기회를 얻어 안전팀에 지원하게되었고 이 곳에서 전문성을 쌓고 팀과 회사에 기여할 수 있는 직원으로 성장하고싶습니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    환경안전팀은 제가 합류하기 전부터 팀워크가 좋기로 소문난 부서였습니다. 실제로 함께 일해보니, 서로에 대한 신뢰와 협업 문화가 잘 자리 잡혀 있는 팀이라는 것을 직접 느낄 수 있었습니다.<br/><br/>
    각자 맡은 업무에 책임감을 가지고 임하면서도, 도움이 필요한 상황에서는 누구랄 것 없이 먼저 나서서 서로를 돕는 분위기였습니다. 특히 제가 업무를 시작한 지 얼마 되지 않았을 때, 현장에 근무하는 인원이 급격히 늘어나 업무협조 요청이 버거웠던 상황이 있었습니다. 그때 제 옆에서 부장님, 차장님이 함께 적극적으로 문제를 해결해주셨고, 다른 사업장이지만 평택에서 근무하시는 선임자분들도 제가 잘 적응할 수 있도록 챙겨주셨습니다.<br/><br/>
    저는 저희 팀이 단순히 일만 잘하는 조직이 아니라, 서로의 역할을 존중하고 응원하며 함께 성장해 나가는 이상적인 팀이라고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 입사 후, 회사에 바라는 점은?</h3>
  <p style="font-size: 1.4rem;">
    기흥, 평택, 본사 등 다양한 사업장에서 많은 임직원들이 근무하고 있는 만큼, 서로 협업하면서도 얼굴을 마주할 기회가 적어 아쉬움을 느낍니다. 이에 직원 간 유대감을 높이고 원활한 소통을 위해, 단합회나 워크숍 등과 같은 사내 프로그램이 활발히 운영되었으면 좋겠습니다.
  </p>

  <h3 style="font-size: 2rem;">Q6. 입사 지원자들에게 해주고 싶은 조언이 있다면?</h3>
  <p style="font-size: 1.4rem;">
    회사에서 업무를 처리하다 보면 누구나 어려움을 느낄 것입니다. 그럴 때 단점을 바라보기보다는 장점을 바라봤으면 좋겠습니다. 저는 서로 응원하고, 협력하며, 동료에게 힘이 되어주는 따뜻한 문화가 비비테크의 가장 큰 장점이라고 생각합니다.<br/><br/>
    따라서 힘든 상황에 처했을 때 이를 피하거나 혼자 모든 부담을 짊어지려 하기보다는 동료나 선임자에게 기대고, 함께 고민하며 해결책을 찾으셨으면 좋겠습니다. 비비테크는 그런 협력적이고 상호 지원적인 환경을 제공하는 회사임을 느끼실 수 있을 겁니다.
  </p>

  <h3 style="font-size: 2rem;">Q7. 앞으로 이 직무에서 어떤 방향으로 성장하고 싶나요?</h3>
  <p style="font-size: 1.4rem;">
    반도체 사업장에서의 현장 업무를 충분히 파악하고, 이를 바탕으로 실질적인 안전 관리 경험을 쌓고 싶습니다. 현장 안전 법규에 대한 숙지가 부족했던 경험이 있어, 향후에는 현장 안전 업무를 더욱 세심하게 챙기고, 현장에서도 주도적인 목소리를 낼 수 있는 능력을 키우고 싶습니다.<br/><br/>
    또한, 법적 서류 처리 및 관련 업무에도 적극적으로 참여하여, 팀에 실질적인 도움이 되는 일원으로 성장해 나갈 계획입니다.
  </p>
</div>
`;

const detailText13 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>자재·장비·서비스의 전략적 조달을 통해 생산 공정의 원활한 진행을 지원</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>분석력과 문제 해결력, 커뮤니케이션 능력, 정직성과 윤리의식</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 분위기</td>
          <td>활발하고 개방적인 분위기, 협업과 소통이 잘 이루어지는 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀의 강점</td>
          <td>다양한 변수에 유연하게 대처하며, 리스크 관리 및 사전 대응에 강점을 보유</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“회사 성장과 본인의 성장을 함께 이끌어갈 분, 함께하길 기다리고 있겠습니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 구매팀은 단순히 필요한 물건을 사는 부서가 아닙니다. 반도체 훅업 공정 시공의 성공을 위해 필수적인 자재, 장비, 서비스 등을 가장 효율적인 조건으로, 적시에 조달하는 역할을 맡고 있습니다. 이런 조달 업무가 제대로 이뤄져야 시공 프로젝트가 차질 없이 진행될 수 있고요, 결국엔 회사의 생산성과 수익성 향상에도 큰 도움이 됩니다.<br/><br/>
    그래서 저희 구매팀은, 프로젝트의 숨은 지원군이자 핵심 파트너라고 자신 있게 말씀드릴 수 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    저는 구매팀에서 전체적인 구매 프로세스를 총괄하고 있는데요.<br/>
    수요 예측부터 계획 수립, 공급업체 발굴, 가격 협상, 계약 체결, 재고 관리까지 다양한 업무를 맡고 있습니다.<br/>
    특히, 공급망 리스크를 사전에 파악하고 문제 발생 시 신속하게 대응할 수 있도록 리스크 관리에도 많은 신경을 쓰고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    이 업무에서 중요한 역량은 크게 세 가지라고 생각합니다. 첫째, 분석력과 문제 해결 능력입니다. 반도체 산업은 빠르게 변하기 때문에, 흐름을 잘 읽고 유연하게 대응해야 하죠. 둘째는 협상력과 커뮤니케이션입니다. 공급업체와도 잘 소통해야 하고, 사내 여러부서와의 협업도 매우 중요합니다.<br/><br/>
    마지막으로는 정직성과 윤리의식입니다. 투명하고 공정한 업무처리는 구매 업무의 기본이자 필수라고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 팀은 활발하고 개방적인 분위기예요. 서로 의견을 자유롭게 나누고, 어려운 상황이 생기면 함께 고민하고 해결하려는 문화가 잘 자리 잡혀 있습니다. 또한, 생산·설계·품질 등 여러 부서와도 긴밀히 협력하며 최고의 결과를 만들어내기 위해 노력하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 구매팀은 도전과 성장이 함께하는 곳입니다. 빠르게 변화하는 산업 환경 속에서 역량을 키우고, 회사의 성장을 함께 이끌고싶은 분이라면 꼭 함께하셨으면 좋겠습니다.<br/><br/>
    함께 미래를 만들어갈 열정 있는 분들, 저희가 기다리고 있겠습니다. 감사합니다!
  </p>
</div>
`;

export const detailText14 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; white-space: nowrap; vertical-align: top;">부서의 핵심 역할</td>
          <td>재무, 회계, 총무, 인사 전반을 담당하며 회사의 안정적 운영 기반을 마련</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>책임감과 신뢰, 꼼꼼함, 유연한 소통력, 변화에 민감한 감각</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 분위기</td>
          <td>따뜻하고 활기찬 분위기, 서로를 ‘동료이자 파트너’로 여기는 문화</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">팀의 강점</td>
          <td>자유로운 의사소통과 협업, 사소한 아이디어도 존중받는 분위기</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원이 망설여진다면</td>
          <td>“혼자가 아닌 ‘같이’의 힘으로, 새로운 시작을 함께하길 바랍니다”</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 부서의 주요 역할은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 경영지원팀은 회사의 ‘든든한 허리’ 역할을 하고 있다고 생각합니다. 눈에 띄지는 않지만 회사가 안정적으로 운영될 수 있도록 보이지 않는 곳에서 서포트하고 챙기는 역할을 하고 있습니다. 재무, 회계, 총무, 인사 등 전사적인 운영을 지원하며, 각 부서가 본연의 업무에 집중할 수 있는 환경을 만들어주는 것이 저희 팀의 가장 중요한 역할이라고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 담당 업무 및 주요 직무 내용을 설명해 주세요</h3>
  <p style="font-size: 1.4rem;">
    경영지원팀은 크게 세가지 축으로 나뉘어 업무를 담당하고 있습니다. 먼저 재무/회계 파트에서는 자금 계획 수립, 회계 결산, 세무 신고 등을 통해 회사의 재무 건전성을 관리합니다.<br /><br />
    총무 파트는 사무환경 개선, 자산 및 비품 관리, 행사 운영 등을 담당해 직원들이 쾌적한 환경에서 일할 수 있도록 지원합니다. 인사 파트는 채용, 평가, 급여, 교육, 복리후생 등 전반적인 인사관리를 통해 조직 구성원의 성장과 만족을 도모하고 있습니다.<br /><br />
    이처럼 경영지원팀은 회사의 전반적인 운영이 원활하게 이루어지도록 각 영역에서 다양한 역할을 수행하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 해당 업무에서 가장 중요한 역량 및 소양 무엇이 있을까요?</h3>
  <p style="font-size: 1.4rem;">
    무엇보다 책임감과 신뢰가 가장 중요하다고 생각합니다. 경영지원 업무는 회사의 중요한 정보와 자산을 다루는 일이 많기 때문에, 꼼꼼함과 윤리의식이 필수입니다. 또한 다양한 부서와의 소통도 많아 커뮤니케이션 능력과 문제 해결 능력도 중요한 요소입니다.<br /><br />
    마지막으로, 변화를 두려워하지 않고 유연하게 사고하는 태도도 필요합니다. 회사의 방향과 외부 환경에 따라 프로세스나 정책이 바뀔 수 있기 때문에, 항상 열린 마음으로 변화를 수용하고 개선하려는 자세가 중요하다고 생각합니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    저희 경영지원팀은 따뜻하고 활기찬 분위기가 큰 자랑입니다. 서로를 ‘동료’이자 ‘파트너’로 여기며, 일이 몰릴 땐 자연스럽게 도와주고, 기쁜 일이 있을 땐 함께 나누는 문화가 잘 형성되어 있습니다.<br /><br />
    또, 수평적인 소통을 중요하게 생각해서 누구든지 자유롭게 의견을 낼 수 있고, 서로의 아이디어에 귀 기울이는 분위기입니다. 업무 특성상 다른 부서와의 협업도 많은데, 그만큼 내부 협업 역량이 팀 전체에 잘 갖춰져 있어 유연하고 민첩하게 움직일 수 있는 게 저희 팀의 강점입니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 지원자에게 당부하고 싶은 말이 있으신가요?</h3>
  <p style="font-size: 1.4rem;">
    경영지원팀은 회사의 ‘숨은 엔진’입니다. 눈에 잘 띄지 않지만, 조직이 멈추지 않고 나아갈 수 있도록 끊임없이 움직이고 고민하는 팀입니다. 작은 일도 소중히 여기고, 꾸준함과 성실함으로 함께 성장해 나가고 싶은 분이라면 언제든지 환영입니다. 혼자보다 ‘같이’의 가치를 중요하게 생각하는 분이시라면, 저희 팀에서 큰 보람을 느끼실 수 있을 겁니다.<br /><br />
    여러분의 새로운 시작을 저희 경영지원팀이 따뜻하게 맞이하겠습니다!
  </p>
</div>
`;

export const detailText15 = `
<div style="line-height: 1.4; font-size: 1.6rem; color: #333;">
  <div style="font-size: 1.4rem; line-height: 1.4; color: #333; margin-bottom: 40px; border-left: 6px solid #D9D9D9; padding-left: 1.2rem;">
    <table class="job-table" style="border-collapse: collapse; line-height: 1.8;">
      <tbody>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">담당 업무</td>
          <td>도면 검토와 정산 등록을 중심으로, 허가서 및 공정 단계별 서류 검토 등 공무 보조 업무 수행</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">핵심 역량</td>
          <td>금액과 데이터가 밀접하게 연결된 업무 특성상, 높은 정확성과 꼼꼼함이 가장 중요함</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원 동기</td>
          <td>전문성과 체계성을 동시에 갖춘 핵심 부서에서 실질적인 관리 역량과 협업 기반의 운영 방식을 배우고자 지원함</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">조직 문화</td>
          <td>실무 중심이면서도 유연한 소통이 가능한 분위기이며, 문제 발생 시 빠르게 정보를 공유하고 함께 해결하는 팀워크가 강점</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">입사 후 바람</td>
          <td>회사의 중장기적인 목표와 방향성이 실무자에게도 명확하게 공유되는 투명한 소통 문화가 지속되길 희망함</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">인상 깊은 순간</td>
          <td>반도체에 대한 기본 개념부터 공정 이해까지 폭넓게 학습했으며, 숫자 중심의 정산 업무도 현장과 연결된 흐름 속에서 이해하려고 노력 중</td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: top;">지원자에게 한마디</td>
          <td>작은 숫자 하나도 현장 전체에 영향을 줍니다. 디테일을 놓치지 않는 눈과 흐름을 읽는 감각이 함께하는 자리입니다.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="min-height:2rem;"></div>
  <h3 style="font-size: 2rem;">Q1. 현재 맡고 있는 담당 업무와 직무 내용은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    도면 검토 및 정산 등록을 중심으로, 허가서와 전·중·후 서류 검토 등 공무 보조 업무도 함께 수행하고 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q2. 해당 업무에서 가장 중요한 역량 및 소양은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    정확성과 꼼꼼함이 가장 중요하다고 생각합니다. 수많은 데이터와 금액이 오가기 때문에 작은 실수도 금전적 손실이나 신뢰 문제로 이어질 수 있기 때문입니다.
  </p>

  <h3 style="font-size: 2rem;">Q3. 우리 회사의 해당 부서에 지원한 이유는 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    전문성과 분석력을 동시에 키울 수 있는 기회라고 생각하며 프로젝트의 완결성을 책임지는 핵심 부서로서 전문성과 체계성을 동시에 갖추고 있는 점에 매력을 느꼈습니다.<br/><br/>
    꼼꼼한 검토와 실질적인 관리 능력이 중요한 이 부서에서, 시스템 기반의 업무 경험과 협업 중심의 운영 방식을 배우고 성장할 수 있을 것이라 생각해 지원하게 되었습니다.
  </p>

  <h3 style="font-size: 2rem;">Q4. 부서의 분위기 및 협업 문화는 어떤가요?</h3>
  <p style="font-size: 1.4rem;">
    제가 속한 부서는 실무 중심이면서도 유연한 소통이 가능한 분위기입니다. 각자 맡은 책임이 명확하지만, 이슈 발생 시에는 서로 적극적으로 정보를 공유하며 함께 해결하는 팀워크 중심의 문화가 형성돼 있습니다.
  </p>

  <h3 style="font-size: 2rem;">Q5. 입사 후, 회사에 바라는 점은?</h3>
  <p style="font-size: 1.4rem;">
    회사가 추구하는 방향성과 목표를 실무자 모두가 충분히 공감하고 이해할 수 있도록, 중장기적인 비전이나 개선 방향에 대해 투명하게 소통하는 문화가 계속 이어지길 바랍니다.
  </p>

  <h3 style="font-size: 2rem;">Q6. 입사 지원자들에게 해주고 싶은 조언이 있다면?</h3>
  <p style="font-size: 1.4rem;">
    반도체 분야는 다양한 영역이 유기적으로 연결되어 있기 때문에, 자신의 직무만 바라보는 시야보다는 산업 전체의 흐름을 이해하려는 넓은 관점이 필요하다고 생각합니다. 이러한 관점을 바탕으로 준비한다면 어떤 직무든 더 빠르게 성장하고, 조직에도 큰 가치를 줄 수 있을 것입니다.
  </p>

  <h3 style="font-size: 2rem;">Q7. 직무를 하면서 새롭게 배운 기술이나 지식은 무엇인가요?</h3>
  <p style="font-size: 1.4rem;">
    반도체 분야는 처음이기 때문에, 가장 먼저 반도체가 무엇인지, 어떻게 만들어지고 어떤 과정을 거쳐 완성되는지에 대한 기본적인 이해부터 쌓았습니다.<br/><br/>
    이러한 배경 지식을 바탕으로, 지금 맡고 있는 정산 업무에서도 단순한 숫자 처리에 그치지 않고, 그 숫자들이 실제 현장과 어떤 연관을 갖는지를 이해하며 일하려고 노력하고 있습니다.
  </p>
</div>
`;




const detailTextList = [
  detailText1, detailText2, detailText3, detailText4, detailText5,
  detailText6, detailText7, detailText8, detailText9, detailText10,
  detailText11, detailText12, detailText13, detailText14, detailText15,
];


const rawPeopleJson = `[
  {
    "department": "반도체사업부 기흥캠퍼스",
    "title": "차별화된 기술력과 현장 중심 관리로 경쟁력을 이끄는 반도체 배관 전문가",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "엄영만 차장"
  },
  {
    "department": "반도체사업부 기흥캠퍼스",
    "title": "배관은 공정의 혈관, 우리는 그 흐름을 설계하고 책임지는 사람들입니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "김상혁 차장"
  },
  {
    "department": "반도체사업부 평택캠퍼스",
    "title": "정확한 공정, 완벽한 배관 시공 - 반도체 설비의 심장을 책임집니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "김윤호 차장"
  },
  {
    "department": "스마트팩토리 사업부",
    "title": "우리는 반도체 제조 자동화의 미래를 설계합니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "강재열 부장"
  },
  {
    "department": "스마트팩토리 사업부",
    "title": "도면 위에 자동화를 설계하고, 현장을 현실로 구현하는 스마트팩토리팀",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "송건의 주임"
  },
  {
    "department": "에코CDR사업부",
    "title": "정해진 길이 아닌, 새로운 길을 개척하는 사람을 찾습니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "김희재 전무"
  },
  {
    "department": "SystemEngineering사업부",
    "title": "고압가스와 특수가스를 다루는 기술, 그 안정성과 책임을 함께 지켜갑니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "양호건 대리"
  },
  {
    "department": "SurfaceTechnology사업부",
    "title": "안전부터 시설, 품질까지 - 공장 운영의 모든 기반을 책임집니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "이해훈 부장"
  },
  {
    "department": "EPC사업부",
    "title": "정확한 수치와 꼼꼼한 정산, 공정 뒤에서 흐름을 책임집니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "서진성 과장"
  },
  {
    "department": "미래기술사업부",
    "title": "작은 오류도 놓치지 않는 품질의 눈으로, 반도체 현장의 신뢰를 만듭니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "박재현 과장"
  },
  {
    "department": "환경안전팀",
    "title": "현장의 안전을 설계하고, 모두의 하루를 지키는 환경안전팀",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "최지희 과장"
  },
  {
    "department": "환경안전팀",
    "title": "현장에 강한 실무형 안전관리자로 성장하겠습니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "도지원 주임"
  },
  {
    "department": "구매팀",
    "title": "단순한 물품 구매가 아닌, 생산성과 수익성 향상을 위한 핵심 파트너입니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "황경용 과장"
  },
  {
    "department": "경영지원팀",
    "title": "회사의 든든한 허리 역할, 보이지 않는 곳에서 안정적 운영을 뒷받침합니다",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "김윤경 부장"
  },
  {
    "department": "반도체사업부 기흥캠퍼스",
    "title": "데이터와 책임 사이, 정밀한 판단으로 완결성을 만드는 공무지원업무",
    "hashtag": "#재무 #회계 #총무 #인사",
    "name": "김현정 주임"
  }
]`;


export type PeoplePost = {
  department: string;       
  title: string;  
  hashtag: string;
  name: string; 
  imageSrc: string;
  imageLargeSrc: string;
  detailText: string;
};

export const peoplePosts: PeoplePost[] = JSON.parse(rawPeopleJson).map((item: PeoplePost, index: number) => ({
  ...item,
  imageSrc: imageList[index % imageList.length],
  imageLargeSrc: imageLargeList[index % imageLargeList.length],
  detailText: detailTextList[index % detailTextList.length]
}));
